module.exports = __webpack_public_path__ + "img/share-bg.27a64ea3.png";